import type { PlacementFormPosition } from "@design-lab/shared/types";

import { track } from "./trackEvent";

/**
 * MN-8890 — emitted when the per-garment-size standard placement resolver does NOT auto-resize.
 * `reason` distinguishes a deliberate fail-safe (unmapped size → manual + CST) from a genuinely
 * mixed-size order (deferred to the MN-9933 per-line-item backend), so we can watch how much order
 * volume isn't auto-classified (Joe B1b) rather than discovering it via customer complaints.
 */
export const trackStandardPlacementFallthrough = (params: {
  placement: PlacementFormPosition;
  reason: "unmapped" | "mixed";
  sizes: string[];
}) => {
  track("design_lab_standard_placement_fallthrough", {
    placement: params.placement,
    reason: params.reason,
    sizes: params.sizes,
    timestamp: Date.now()
  });
};
